// src/utils/cacheUtils.js

/**
 * Clear all application cache from localStorage on logout
 */
export const clearAllCache = () => {
    try {
        console.log('Clearing all application cache...');

        // Cache keys to remove
        const cacheKeys = [
            // Appointments cache
            'salon_appointments_cache_metadata',
            'salon_appointments_monthly_summary_cache',
            'salon_appointments_dashboard_metrics_cache',
            // Dashboard metrics cache
            'salon_dashboard_metrics_cache',
            // Other entity caches
            'salon_customers_cache',
            'salon_customers_timestamp',
            'salon_services_cache',
            'salon_services_timestamp',
            'salon_crew_members_cache',
            'salon_crew_members_timestamp'
        ];

        // Remove specific cache keys
        cacheKeys.forEach(key => {
            localStorage.removeItem(key);
        });

        // Remove all week-based appointment caches (salon_appointments_week_*)
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('salon_appointments_cache_week_') ||
                key.startsWith('salon_monthly_appointments_summary_cache')) {
                localStorage.removeItem(key);
            }
        });

        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('customer-actions')){
                localStorage.removeItem(key);
            }
        });

        console.log('Successfully cleared all application cache');

    } catch (error) {
        console.error('Error clearing cache:', error);
    }
};